import getUrlOverrides from '../utils/overrides/getUrlOverrides';
import { setLogicalRing } from 'owa-config/lib/getLogicalRing';
import calculateLogicalRing from '../utils/calculateLogicalRing';
import { getLocalStorageOverrides } from '../utils/overrides/localStorageOverrides';
import { setDefaultFlags } from '../utils/defaultFlags';
import { getFlagsEnabledByRing } from '../utils/getFlagsEnabledByRing';
import getFeatureFlagsKeyForSourceId from '../utils/getFeatureFlagsKeyForSourceId';
import store from '../store/Store';

export const FEATURES_QUERYSTRING_PARAMETER_NAME = 'features';
export const FLIGHT_DEVTOOLS_NAME = 'fwk-devtools';

const featureFlagsInitialized: Set<string> = new Set();
export function areFeatureFlagsInitialized(sourceId: string | undefined): boolean {
    return featureFlagsInitialized.has(getFeatureFlagsKeyForSourceId(sourceId));
}

type FlagsFromServiceObject = {
    [key: string]: boolean;
};

function initializeFeatureFlags(flagsFromService?: string[], sourceId?: string) {
    let flagsFromServiceObject: FlagsFromServiceObject = {};
    if (flagsFromService) {
        flagsFromServiceObject = flagsFromService.reduce(
            (agg: FlagsFromServiceObject, flagFromService) => {
                agg[flagFromService.toLowerCase()] = true;
                return agg;
            },
            {}
        );
    }
    const logicalRing = calculateLogicalRing(feature => flagsFromServiceObject[feature]);
    addOverrides(flagsFromServiceObject, getFlagsEnabledByRing(logicalRing));
    setLogicalRing(logicalRing);
    setDefaultFlags(makeDefaultFlags(flagsFromServiceObject));

    if (logicalRing == 'Dogfood' && !sourceId) {
        addOverrides(flagsFromServiceObject, getLocalStorageOverrides());
    }
    if (flagsFromServiceObject[FLIGHT_DEVTOOLS_NAME] && !sourceId) {
        addOverrides(flagsFromServiceObject, getUrlOverrides(FEATURES_QUERYSTRING_PARAMETER_NAME));
    }
    store(sourceId).featureFlags = new Map<string, boolean>(
        Object.keys(flagsFromServiceObject).map(key => [key, flagsFromServiceObject[key]])
    );
    featureFlagsInitialized.add(getFeatureFlagsKeyForSourceId(sourceId));
    return flagsFromServiceObject;
}

function addOverrides(
    flags: { [feature: string]: boolean },
    overrides: { [feature: string]: boolean }
): void {
    for (let key of Object.keys(overrides)) {
        flags[key.toLowerCase()] = overrides[key];
    }
}

function makeDefaultFlags(flags: {}) {
    let defaultFlags = {};
    for (let key of Object.keys(flags)) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (71,9): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        // @ts-expect-error
        defaultFlags[key] = flags[key];
    }
    return defaultFlags;
}

export default initializeFeatureFlags;
